import { render, staticRenderFns } from "./BalancedSummary.vue?vue&type=template&id=4f353dc6&"
import script from "./BalancedSummary.vue?vue&type=script&lang=js&"
export * from "./BalancedSummary.vue?vue&type=script&lang=js&"
import style0 from "./BalancedSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VProgressLinear,VSimpleTable})
